import { render, staticRenderFns } from "./TestAvatarGroup.vue?vue&type=template&id=b0c58d6c&"
import script from "./TestAvatarGroup.vue?vue&type=script&lang=js&"
export * from "./TestAvatarGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports